var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Row, Col } from "react-bootstrap";
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import Hr from "@irati/ui/src/Layout/Hr";
import { H1 } from "@irati/ui/src/Typography";
import { SmallCaption } from "@irati/ui/src/Labels";
import Loading from "@irati/ui/src/Loading";
import Card from "@irati/ui/src/Layout/Card";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import savedCardsEmpty from "@irati/ui/images/saved-cards-empty.png";
import { getSavedCards, deleteSavedCard } from "@irati/payments/services/SavedCards";
import UserSavedPaymentCard from "../../components/UserSavedPaymentCard/UserSavedPaymentCard";
import EmptyState from "../../components/EmptyState/EmptyState";
var RightCol = styled(Col)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: right;\n"], ["\n  text-align: right;\n"])));
var UpdateUserPaymentContainer = /** @class */ (function (_super) {
    __extends(UpdateUserPaymentContainer, _super);
    function UpdateUserPaymentContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.removePaymentMethod = function (card) {
            deleteSavedCard(card).then(function () {
                _this.setState(function (state) { return ({
                    savedCards: state.savedCards.filter(function (savedCard) { return savedCard.reference !== card.reference; })
                }); });
            });
        };
        _this.state = {
            savedCards: [],
            load: getSavedCards().then(function (_a) {
                var results = _a.results;
                _this.setState({ savedCards: results });
            })
        };
        return _this;
    }
    UpdateUserPaymentContainer.prototype.render = function () {
        var _this = this;
        var formatMessage = this.props.formatMessage;
        var _a = this.state, savedCards = _a.savedCards, load = _a.load;
        return (React.createElement(Card, { tiny: true, noBorder: true },
            React.createElement(H1, { marginBottom: 4 },
                React.createElement(FormattedMessage, { id: "account.payment.header" })),
            React.createElement(Loading, { load: load },
                savedCards.length > 0 && (React.createElement("div", null,
                    React.createElement(Row, null,
                        React.createElement(Col, { xs: 3 },
                            React.createElement(SmallCaption, { uppercase: true },
                                React.createElement(FormattedMessage, { id: "account.payment.headers.cardType" }))),
                        React.createElement(Col, { xs: 3 },
                            React.createElement(SmallCaption, { uppercase: true },
                                React.createElement(FormattedMessage, { id: "account.payment.headers.cardName" }))),
                        React.createElement(RightCol, { xs: 2 },
                            React.createElement(SmallCaption, { uppercase: true },
                                React.createElement(FormattedMessage, { id: "account.payment.headers.cardNumber" }))),
                        React.createElement(RightCol, { xs: 2 },
                            React.createElement(SmallCaption, { uppercase: true },
                                React.createElement(FormattedMessage, { id: "account.payment.headers.cardExpDate" })))),
                    React.createElement(Hr, { marginTop: 1 }),
                    savedCards.map(function (card) { return (React.createElement(Fragment, { key: card.reference },
                        React.createElement(UserSavedPaymentCard, __assign({ removePaymentMethod: function () { return _this.removePaymentMethod(card); } }, card)),
                        React.createElement(Hr, null))); }))),
                savedCards.length === 0 && (React.createElement(EmptyState, { description: formatMessage({ id: "account.payment.empty" }), src: savedCardsEmpty, alt: formatMessage({ id: "account.payment.alt" }) })))));
    };
    return UpdateUserPaymentContainer;
}(Component));
var mapStateToProps = function (state) {
    return {
        user: state.auth.user
    };
};
var UpdateUserPayment = connect(mapStateToProps)(UpdateUserPaymentContainer);
export default injectIntl(UpdateUserPayment);
var templateObject_1;
